import { Component, AfterViewInit, ElementRef } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';

export interface Testimonial {
  picture: string;
  link: string;
  handle: string;
  text: string;
  bgPosition: string;
  source: 'instagram' | 'amazon';
}

@Component({
  standalone: true,
  imports: [CarouselModule],
  selector: 'app-depoimentos',
  templateUrl: './depoimentos.component.html',
  styleUrls: ['./depoimentos.component.css']
})
export class DepoimentosComponent implements AfterViewInit {

  readonly testimonials: Testimonial[] = [
    {
      picture: '/assets/images/comment/pam-comment.jpg',
      link: 'https://www.instagram.com/p/CnpJgqprI4F/?utm_source=ig_web_copy_link&igshid=MWQ1ZGUxMzBkMA==',
      handle: '@leituras.da.pam',
      text: 'O autor foi bastante criativo com o universo do enredo, descrevendo tudo em detalhes sem tornar a leitura cansativa. Pelo contrário, sua escrita é fluída e a narrativa possui MUITA AÇÃO.',
      bgPosition: '1px -57px',
      source: 'instagram'
    },
    {
      picture: '/assets/images/comment/natalia-comment.png',
      link: 'https://www.instagram.com/p/CW3f62_rQXO/?utm_source=ig_web_copy_link',
      handle: '@livrossaofilhos',
      text: 'O livro tem cada cena maravilhosa, parecia que eu estava lá vendo tudo como num filme, as cenas de luta e ação me cativaram e me fizeram torcer bastante.',
      bgPosition: '1px -67px',
      source: 'instagram'
    },
    {
      picture: '/assets/images/comment/jonny-comment.jpeg',
      link: 'https://www.instagram.com/p/CU75_UBLoex/?utm_source=ig_web_copy_link',
      handle: '@iamjohniev',
      text: 'É aquela história que te leva em uma imersão de aventuras e mistérios, onde cada revelação torna-se novidade não só para o leitor mas também para o protagonista.',
      bgPosition: '1px 1px',
      source: 'instagram'
    },
    {
      picture: '/assets/images/comment/lari-comment.jpg',
      link: 'https://www.instagram.com/p/CWl7KK8LMz1/?utm_source=ig_web_copy_link',
      handle: '@leituradalari',
      text: 'Eu tô apaixonada na escrita do autor, sabe aquela escrita que te instiga a querer ler cada vez mais? É isso que teremos aqui, uma escrita envolvente, fluída, cativante com uma história bem original e até mesmo genial.',
      bgPosition: '2px 1px',
      source: 'instagram'
    },
    {
      picture: '/assets/images/comment/andreia-comment.jpg',
      link: 'https://www.instagram.com/p/CaVpHGKL-lL/?utm_source=ig_web_copy_link&igshid=MWQ1ZGUxMzBkMA==',
      handle: '@andreia_books',
      text: 'Durante toda a leitura eu fiquei me perguntando o que seria de Henshi, quem era ele de fato, qual o papel de seus pais naquela sociedade e se ele encontraria o que buscava.',
      bgPosition: '0px -25px',
      source: 'instagram'
    },
    {
      picture: '/assets/images/comment/debora-comment.jpg',
      link: 'https://www.amazon.com.br/gp/customer-reviews/REPV1ASPEU10/ref=cm_cr_dp_d_rvw_ttl?ie=UTF8&ASIN=B09NZ58ZQN',
      handle: '@literazil',
      text: 'Um enredo com muitas cenas de ação, mistérios, reviravoltas... Por se tratar do primeiro livro da saga, muitas perguntas ficam em aberto e devem ser respondidas nos próximos livros.',
      bgPosition: '1px 1px',
      source: 'amazon'
    },
    {
      picture: '/assets/images/comment/bia-comment.jpg',
      link: 'https://www.amazon.com.br/gp/customer-reviews/R3CPQB2U3KDHBS/ref=cm_cr_dp_d_rvw_ttl?ie=UTF8&ASIN=B09NZ58ZQN',
      handle: '@revolucaodoslivros',
      text: 'Esse é um livro repleto de ação, mistérios, lutas e a introdução de um novo universo. Fiquei constantemente curiosa pra descobrir junto ao protagonista toda sua história.',
      bgPosition: '1px -48px',
      source: 'amazon'
    },
    {
      picture: '/assets/images/comment/leo-comment.jpg',
      link: 'https://www.instagram.com/p/CgXYSJpvsbS/?utm_source=ig_web_copy_link&igshid=MWQ1ZGUxMzBkMA==',
      handle: '@poraoliterario',
      text: 'A ambientação de Breakers é incrível, gostei bastante dos detalhes que o autor atribuiu ao seu mundo e todos os nuances dos personagens secundários, principalmente o Marcus!',
      bgPosition: '-33px -10px',
      source: 'instagram'
    },
    {
      picture: '/assets/images/comment/yasmin-comment.jpeg',
      link: 'https://www.instagram.com/p/Ccft6m9Lgt_/?utm_source=ig_web_copy_link&igshid=MWQ1ZGUxMzBkMA==',
      handle: '@yasliterarte',
      text: '"A Queda das Chamas" me deixou viciada e encantada. O autor, Aaron, possui uma escrita envolvente e construiu personagens cativantes que apresentam várias camadas.',
      bgPosition: '4px -94px',
      source: 'instagram'
    },
    {
      picture: '/assets/images/comment/fern-comment.jpg',
      link: 'https://www.instagram.com/p/CY1SmXqO5s_/?utm_source=ig_web_copy_link&igshid=MWQ1ZGUxMzBkMA==',
      handle: '@blog.modoliterario',
      text: 'Um dos destaques dessa obra é a ambientação compreendida, já que transporta o leitor para um universo único e muito bem desenvolvido.',
      bgPosition: '0px -164px',
      source: 'instagram'
    }
  ];

  readonly responsiveOptions = [
    { breakpoint: '1280px', numVisible: 3, numScroll: 1 },
    { breakpoint: '900px',  numVisible: 2, numScroll: 1 },
    { breakpoint: '560px',  numVisible: 1, numScroll: 1 }
  ];

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    const animatedEls: NodeListOf<Element> = this.el.nativeElement.querySelectorAll('.anim');
    animatedEls.forEach((el: Element) => observer.observe(el));
  }
}
